import TextInput from './inputs/TextInput.vue'
import FullPageLoading from './loading/FullPageLoading'
import ModalWindow from './modals/ModalWindow'
import ThankYou from './modals/ThankYou'
import ImageItem from './lazy/ImageItem'

export default [
    TextInput, FullPageLoading, ModalWindow, ThankYou, ImageItem
]